import { apiCadastro } from "./utils/api";

const normalizeOptionalId = (value) => {
  if (value === null || value === undefined) return null;
  if (typeof value === "string" && value.trim() === "") return null;
  if (value === 0 || value === "0") return null;
  if (typeof value === "string") {
    const numericValue = Number(value);
    return Number.isInteger(numericValue) ? numericValue : null;
  }
  return value;
};

export const getProspect = async () => {
  const data = [
    {
      id: 1234,
      codigo: 1185297,
      razao: "VANCOUVER INVESTIMENTOS IMOBILIARIO",
      cnpj: 8302494000170,
      segmento: "VC-SIST TRAD_GRR",
      grupoCentralizador: "TECNISA",
      bairro: "Caiçara",
      cargo: "Engenheiro Civil",
      cep: "11707-120",
      cidade: "Praia Grande",
      classificacaoFiscal: "Classe B",
      codigoSAP: "SAP54321",
      codigoVendedor: "VEND9876",
      complemento: "Bloco B, Apt 202",
      cpf: "123.456.789-01",
      dataDaNegociacao: "27/07/2023",
      email: "engenheiro2@vancouver.com",
      faseDeObra: "Estrutura",
      filialEngemix: "SANTOS",
      grupoSegmento: "Construtora",
      nome: "Maria Souza",
      nomeFantasia: "Vancouver Engenharia",
      numero: 422,
      numeroDePavimentos: 18,
      phone: "(45) 98765-4321",
      produto: "Construção Residencial",
      quantidadeDeTorres: 2,
      rua: "Av. das Palmeiras",
      sistemaConstrutivo: "Pré-moldado",
      sobreNome: "Souza",
      tel: "(21) 8765-4321",
      tipoPessoa: "Pessoa Jurídica",
      trilha: "Engenharia Civil",
      trilhaGlobal2: "Construção",
      uf: "SP",
      volumePotencial: 3
    },
    {
      id: 1243,
      codigo: 1285298,
      razao: "ABC Construções",
      cnpj: 9876543210001,
      segmento: "Construção Civil",
      grupoCentralizador: "Grupo ABC",
      bairro: "Centro",
      cargo: "Arquiteto",
      cep: "12345-678",
      cidade: "São Paulo",
      classificacaoFiscal: "Classe C",
      codigoSAP: "SAP98765",
      codigoVendedor: "VEND1234",
      complemento: "Apto 301",
      cpf: "789.012.345-67",
      dataDaNegociacao: "15/08/2023",
      email: "arquiteto@abcconstrucoes.com",
      faseDeObra: "Projeto",
      filialEngemix: "MORUMBI",
      grupoSegmento: "Construtora",
      nome: "Joana Oliveira",
      nomeFantasia: "ABC Arquitetura",
      numero: 123,
      numeroDePavimentos: 10,
      phone: "(11) 2345-6789",
      produto: "Projeto Residencial",
      quantidadeDeTorres: 1,
      rua: "Rua das Flores",
      sistemaConstrutivo: "Estrutural",
      sobreNome: "Oliveira",
      tel: "(11) 9876-5432",
      tipoPessoa: "Pessoa Jurídica",
      trilha: "Arquitetura",
      trilhaGlobal2: "Construção",
      uf: "SP",
      volumePotencial: 1
    },
    {
      id: 2341,
      codigo: 1385299,
      razao: "Cia. de Construções Modernas",
      cnpj: 4567890120001,
      segmento: "Engenharia Estrutural",
      grupoCentralizador: "Construções Modernas",
      bairro: "Alphaville",
      cargo: "Gerente de Projetos",
      cep: "06541-123",
      cidade: "Barueri",
      classificacaoFiscal: "Classe A",
      codigoSAP: "SAP13579",
      codigoVendedor: "VEND5678",
      complemento: "Sala 501",
      cpf: "987.654.321-09",
      dataDaNegociacao: "10/09/2023",
      email: "gerente@construcoesmodernas.com",
      faseDeObra: "Construção Civil",
      filialEngemix: "ALPHAVILLE",
      grupoSegmento: "Construtora",
      nome: "Luiz Mendes",
      nomeFantasia: "Construções Modernas",
      numero: 789,
      numeroDePavimentos: 20,
      phone: "(11) 7654-3210",
      produto: "Construção Comercial",
      quantidadeDeTorres: 1,
      rua: "Avenida Principal",
      sistemaConstrutivo: "Estrutural",
      sobreNome: "Mendes",
      tel: "(11) 9876-5432",
      tipoPessoa: "Pessoa Jurídica",
      trilha: "Engenharia Civil",
      trilhaGlobal2: "Construção",
      uf: "SP",
      volumePotencial: 2
    },
    {
      id: 1324,
      codigo: 1485300,
      razao: "RJ Construções",
      cnpj: 3030303030001,
      segmento: "Construção Residencial",
      grupoCentralizador: "RJ Engenharia",
      bairro: "Copacabana",
      cargo: "Engenheiro de Produção",
      cep: "22000-001",
      cidade: "Rio de Janeiro",
      classificacaoFiscal: "Classe B",
      codigoSAP: "SAP30303",
      codigoVendedor: "VEND3030",
      complemento: "Apto 501",
      cpf: "111.222.333-44",
      dataDaNegociacao: "05/08/2023",
      email: "engenheiro@rjconstrucoes.com",
      faseDeObra: "Execução",
      filialEngemix: "COPACABANA",
      grupoSegmento: "Construtora",
      nome: "Carlos Santos",
      nomeFantasia: "RJ Construções",
      numero: 50,
      numeroDePavimentos: 12,
      phone: "(21) 9876-5432",
      produto: "Construção de Apartamentos",
      quantidadeDeTorres: 3,
      rua: "Avenida Atlântica",
      sistemaConstrutivo: "Concreto Armado",
      sobreNome: "Santos",
      tel: "(21) 7654-3210",
      tipoPessoa: "Pessoa Jurídica",
      trilha: "Engenharia Civil",
      trilhaGlobal2: "Construção",
      uf: "RJ",
      volumePotencial: 4
    },
    {
      id: 1342,
      codigo: 1585301,
      razao: "Construções ABCD",
      cnpj: 5555555550001,
      segmento: "Construção Comercial",
      grupoCentralizador: "Grupo ABCD",
      bairro: "Brooklin",
      cargo: "Gerente de Obras",
      cep: "04578-901",
      cidade: "São Paulo",
      classificacaoFiscal: "Classe C",
      codigoSAP: "SAP55555",
      codigoVendedor: "VEND5555",
      complemento: "Conjunto 301",
      cpf: "333.444.555-66",
      dataDaNegociacao: "12/10/2023",
      email: "gerente@construcoesabcd.com",
      faseDeObra: "Construção de Escritórios",
      filialEngemix: "BROOKLIN",
      grupoSegmento: "Construtora",
      nome: "Mariana Silva",
      nomeFantasia: "Construções ABCD",
      numero: 100,
      numeroDePavimentos: 30,
      phone: "(11) 5555-4444",
      produto: "Escritórios Corporativos",
      quantidadeDeTorres: 1,
      rua: "Avenida Brooklin",
      sistemaConstrutivo: "Estrutural",
      sobreNome: "Silva",
      tel: "(11) 4444-5555",
      tipoPessoa: "Pessoa Jurídica",
      trilha: "Engenharia Civil",
      trilhaGlobal2: "Construção",
      uf: "SP",
      volumePotencial: 5
    }
  ];

  // Retorne o array data com os objetos preenchidos
  return data;

}

export const getSolicitations = async (vendedorSelecionado = null) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Solicitacao`, { params: { usuarioId: vendedorSelecionado } }).then((response) => response.data);
  return res;
};

export const getReenviarSolicitacao = async (idSolicitacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.post(`/api/Solicitacao/Reenviar/${idSolicitacao}`).then((response) => response.data);
  return res;
}

export const salvarProspect = async (camposProspect) => {
  if (!navigator.onLine) {
    return null;
  }
  const fields = {
    ...camposProspect,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposProspect.grupoCentralizadorConstrutoraId),
  };

  const res = await apiCadastro.post('/api/Cliente/Prospect', fields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const atualizarProspect = async (camposProspect) => {
  if (!navigator.onLine) {
    return null;
  }
  const fields = {
    ...camposProspect,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposProspect.grupoCentralizadorConstrutoraId),
  };

  const res = await apiCadastro.put(`/api/Cliente/Prospect/${camposProspect.id}`, fields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const vincularProspect = async (camposProspect) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.post(`/api/Cliente/Prospect/Vinculacao/`, camposProspect).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const getDocumentos = async (take) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Documentos`, { params: { take: take } }).then((response) => response.data);
  return res;
}

export const buscaCep = async (cep) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Endereco/Cep/${cep}`).then((response) => response.data);
  return res;
}

export const buscaOnline = async (busca) => {
  if (!navigator.onLine) {
    return null;
  }
  try {
    const response = await apiCadastro.get(`/api/Cliente/BuscaOnline/Busca`, {
      params: { busca },
      validateStatus: (status) => true
    });
    return { data: response.isSuccess ? response.data : response };
  } catch (error) {
    console.error('Erro na busca online:', error);
    return null;
  }
};

export const buscaEmissor = async (documento) => {
  if (!navigator.onLine) {
    return { isOffline: true };
  }

  try {
    const response = await apiCadastro.get(`/api/Cliente/BuscaEmissor`, {
      params: { documento },
      validateStatus: () => true,
    });

    return {
      data: response?.data,
      status: response?.status,
      isSuccess: response?.status >= 200 && response?.status < 300,
    };
  } catch (error) {
    console.error("Erro ao buscar emissor por documento:", error);

    return {
      data: error?.response?.data,
      status: error?.response?.status,
      isSuccess: false,
    };
  }
};

export const buscaCeps = async (skip, take, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Endereco/Ceps/Vendedor`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response);
  return res;
}

export const buscaAllCeps = async (skip, take, estado, dataAtualizacao) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Endereco/Ceps/Estado/${estado}`, { params: { take: take, skip: skip, dataAtualizacao: dataAtualizacao } }).then((response) => response.data);
  return res;
}


export const salvarEmissor = async (camposEmissor) => {
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    ...camposEmissor,
    dataNascimento: camposEmissor.dataNascimento ? camposEmissor.dataNascimento.split('/').reverse().join('-') : null,
    formaRecebimentoNFE: camposEmissor.recebimento,
    grupoCentralizadorId: camposEmissor.grupoCentralizadorId && camposEmissor.grupoCentralizadorId != "" ? camposEmissor.grupoCentralizadorId : null,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposEmissor.grupoCentralizadorConstrutoraId)
  }

  const res = await apiCadastro
  .post("/api/Cliente/Emissor", fields)
  .then((response) => {
    if (response?.data === undefined) {
      return { data: response };
    }
    return response;
  });

return res;
};

export const salvarConversao = async (camposEmissor) => {
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    ...camposEmissor,
    dataNascimento: camposEmissor.dataNascimento ? camposEmissor.dataNascimento.split('/').reverse().join('-') : null,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposEmissor.grupoCentralizadorConstrutoraId),
  }

  const res = await apiCadastro.post('/api/Cliente/Prospect/Conversao', fields).then((response) => {
    if (response.data === undefined) return response;
    return response.data;
  });
  return res;
};

export const atualizarEmissor = async (camposEmissor) => {
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    id: camposEmissor.id,
    celular: camposEmissor?.contatos[0]?.celular || '',
    telefone: camposEmissor?.contatos[0]?.telefone || '',
    email: camposEmissor?.contatos[0]?.email || '',
    formaRecebimentoNFE: camposEmissor.formaRecebimento ?? camposEmissor.recebimento,
    trilhaId: camposEmissor.trilhaId,
    classificacaoFiscal: camposEmissor.classificacaoFiscal,
    grupoCentralizadorId: camposEmissor.grupoCentralizadorId || null,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposEmissor.grupoCentralizadorConstrutoraId),
    grupoSegmentoId: camposEmissor.grupoSegmentoId || null,
    segmentoId: camposEmissor.segmentoId,
    descargaCliente: camposEmissor.descargaCliente,
    descargaFumaca: false,
    diasAntecipacao: 0,
    contatos: camposEmissor.contatos,
    dataNascimento: camposEmissor.dataNascimento ? camposEmissor.dataNascimento.split('/').reverse().join('-') : null,
    numero: camposEmissor.numero,
    complemento: camposEmissor.complemento,
    equipeVendaId: camposEmissor.equipeVendaId || null,
    escritorioVendaId: camposEmissor.escritorioVendaId || null,
    nomeObra: camposEmissor.nomeObra || null
  };

  const res = await apiCadastro.put(`/api/Cliente/Emissor/${camposEmissor.id}`, {
    clienteDTO: camposEmissor,
    ...fields
  }).then((response) => {
    if (response?.data === undefined) {
      return { data: response };
    }
    return response;
  });
  return res;
};

export const atualizarRecebedor = async (camposRecebedor) => {
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    id: camposRecebedor.id,
    contatos: camposRecebedor.contatos,
    trilhaId: camposRecebedor.trilhaId || null,
    classificacaoFiscal: camposRecebedor.classificacaoFiscal,
    grupoCentralizadorId: camposRecebedor.grupoCentralizadorId || null,
    grupoCentralizadorConstrutoraId: normalizeOptionalId(camposRecebedor.grupoCentralizadorConstrutoraId),
    grupoSegmentoId: camposRecebedor.grupoSegmentoId || null,
    segmentoId: camposRecebedor.segmentoId || null,
    descargaCliente: camposRecebedor.descargaCliente,
    descargaFumaca: camposRecebedor.descargaFumaca,
    diasAntecipacao: 0,
    numero: camposRecebedor.numero,
    complemento: camposRecebedor.complemento,
    formaRecebimentoNFE: camposRecebedor.formaRecebimento ?? camposRecebedor.recebimento,
    equipeVendaId: camposRecebedor.equipeVendaId || null,
    escritorioVendaId: camposRecebedor.escritorioVendaId || null,
    nomeObra: camposRecebedor.nomeObra || null
  };

  const res = await apiCadastro.put(`/api/Cliente/Recebedor/${camposRecebedor.id}`, fields)
    .then((response) => response);
  return res;
};

export const salvarRecebedor = async (camposRecebedor) => {
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    ...camposRecebedor,
    clienteEmissor: {
      ...camposRecebedor.clienteEmissor,
      dataNascimento: camposRecebedor.clienteEmissor.dataNascimento ? camposRecebedor.clienteEmissor.dataNascimento.split('/').reverse().join('-') : null,
      classificacaoFiscal: camposRecebedor.clienteEmissor.classificacaoFiscal ?? "",
      segmentoId: camposRecebedor.clienteEmissor.segmentoId && camposRecebedor.clienteEmissor.segmentoId != "" ? camposRecebedor.clienteEmissor.segmentoId : null,
      grupoSegmentoId: camposRecebedor.clienteEmissor.grupoSegmentoId && camposRecebedor.clienteEmissor.grupoSegmentoId != "" ? camposRecebedor.clienteEmissor.grupoSegmentoId : null,
      grupoCentralizadorConstrutoraId: normalizeOptionalId(camposRecebedor.clienteEmissor.grupoCentralizadorConstrutoraId),
    },
    clienteRecebedor: {
      ...camposRecebedor.clienteRecebedor,
      documento: camposRecebedor.clienteEmissor.documento,
      dataNascimento: camposRecebedor.clienteRecebedor.dataNascimento ? camposRecebedor.clienteRecebedor.dataNascimento.split('/').reverse().join('-') : null,
      classificacaoFiscal: camposRecebedor.clienteRecebedor.classificacaoFiscal ?? "",
      segmentoId: camposRecebedor.clienteRecebedor.segmentoId && camposRecebedor.clienteRecebedor.segmentoId != "" ? camposRecebedor.clienteRecebedor.segmentoId : null,
      grupoSegmentoId: camposRecebedor.clienteRecebedor.grupoSegmentoId && camposRecebedor.clienteRecebedor.grupoSegmentoId != "" ? camposRecebedor.clienteRecebedor.grupoSegmentoId : null,
      grupoCentralizadorId: camposRecebedor.clienteRecebedor.grupoCentralizadorId && camposRecebedor.clienteRecebedor.grupoCentralizadorId != "" && camposRecebedor.clienteRecebedor.grupoCentralizadorId != 0 ? camposRecebedor.clienteRecebedor.grupoCentralizadorId : null,
      grupoCentralizadorConstrutoraId: normalizeOptionalId(camposRecebedor.clienteRecebedor.grupoCentralizadorConstrutoraId),
    }
  };

 const res = await apiCadastro
  .post("/api/Cliente/Recebedor", fields)
  .then((response) => {
    if (response?.data === undefined) {
      return { data: response };
    }

    return response;
  });

return res;
};

export const salvarBuscaOnline = async (camposRecebedor) => {
  console.log(`salvar busca online`)
  if (!navigator.onLine) {
    return null;
  }
  let fields = {
    ...camposRecebedor,
    clienteEmissor: {
      ...camposRecebedor.clienteEmissor,
      dataNascimento: camposRecebedor.clienteEmissor.dataNascimento ? camposRecebedor.clienteEmissor.dataNascimento.split('/').reverse().join('-') : null,
      grupoCentralizadorConstrutoraId: normalizeOptionalId(camposRecebedor.clienteEmissor.grupoCentralizadorConstrutoraId)
    },
    clienteRecebedor: {
      ...camposRecebedor.clienteRecebedor,
      documento: camposRecebedor.clienteEmissor.documento,
      dataNascimento: camposRecebedor.clienteRecebedor.dataNascimento ? camposRecebedor.clienteRecebedor.dataNascimento.split('/').reverse().join('-') : null,
      grupoCentralizadorConstrutoraId: normalizeOptionalId(camposRecebedor.clienteRecebedor.grupoCentralizadorConstrutoraId)
    }
  };

  const res = await apiCadastro
  .post("/api/Cliente/BuscaOnline", fields)
  .then((response) => {
    if (response?.data === undefined) {
      return { data: response };
    }
    console.log(response, `response`)
    return response;
  });

return res;
};

const processDate = (dateString) => {
  if (!dateString?.replaceAll(' ', '').length) return null;

  return dateString.trim().split('/').reverse().join('-');
};

const processClientFields = (client) => {
  if (!client || Object.entries(client).length === 0) return null;

  const processed = {
    ...client,
    segmentoId: client.segmentoId || null,
    grupoSegmentoId: client.grupoSegmentoId || null,
    grupoCentralizadorId: (client.grupoCentralizadorId && client.grupoCentralizadorId != 0)
      ? client.grupoCentralizadorId
      : null,
    dataNascimento: processDate(client.dataNascimento)
  };

  if (client.produtos) {
    processed.produtos = client.produtos.map(e => e.value);
  }

  return processed;
};

const buildFormData = (fields) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(fields)) {
    if (key === 'documentos') continue;

    if (typeof value === 'object' && value !== null) {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  }

  if (fields.documentos) {
    for (const file of fields.documentos) {
      if (file?.file) {
        formData.append('files', file.file);
      }
    }
  }


  return formData;
};


export const salvarLimite= async (camposLimite) => {
  console.log(camposLimite, `camposLimite`)
  const fields = { ...camposLimite };

 const emissor = processClientFields(fields.clienteEmissor);
    if (emissor) {
      fields.clienteEmissor = emissor;
    } else {
      delete fields.clienteEmissor;
    }

    const recebedor = processClientFields(fields.clienteRecebedor);
    if (recebedor) {
      fields.clienteRecebedor = recebedor;
    } else {
      delete fields.clienteRecebedor;
    }

  const formData = buildFormData(fields);
  console.log(formData, `full`)
  const res = await apiCadastro.post('/api/Credito', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res;
};

export const getCarteiraClientes = async (take, skip, vendedorId = null) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Carteira`, { params: { take: take, skip: skip, usuarioId: vendedorId } });
  return res;
}

export const getCarteiraProspects = async (take, skip, vendedorId = null) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Carteira/Prospect`, { params: { take: take, skip: skip, usuarioId: vendedorId } });
  return res;
}

export const getCarteiraIdClientes = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/CarteiraIds`).then((response) => response.data);
  return res;
}

export const getCarteiraIdProspects = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/CarteiraIds/Prospect`).then((response) => response.data);
  return res;
}

export const getNaoCarteiraIdClientes = async () => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/NaoCarteiraIds`).then((response) => response.data);
  return res;
}

export const getClienteCarteira = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  if (!id) return null;

  const res = await apiCadastro.get(`/api/Cliente/Carteira/` + id).then((response) => response.data);
  return res;
}

export const getProspectCarteira = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Carteira/Prospect/` + id).then((response) => response.data);
  return res;
}

export const getCliente = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Carteira/${id}`).then((response) => response.data).catch(error_ => error_.response);
  return res;
}

export const getClienteCreditos = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Credito/Cliente/${id}`).then((response) => response.data).catch(error_ => error_.response);
  return res;
}

export const setInativarProspect = async (id) => {
  if (!navigator.onLine) {
    return null;
  }
  const res = await apiCadastro.get(`/api/Cliente/Prospect/Inativacao/${id}`).then((response) => response.data).catch(error_ => error_.response);
  return res;
}